import { z } from 'zod'
import { Capability } from './steps.js'

/**
 * Container = ĐANG CHẠY Ở ĐÂU. Do partner khai báo lúc onboard, BE snapshot vào session.
 * FE không bao giờ sniff user-agent — UA trong WebView của bank sai gần như chắc chắn.
 */
export const ContainerType = z.enum([
  /** WebView nhúng trong app. Không có camera đáng tin, không có thanh địa chỉ. */
  'app_webview',
  /** Custom Tabs (Android) / SFSafariViewController (iOS). Có camera, cookie hoạt động bình thường. */
  'app_browser_tab',
  /** Trình duyệt thường. */
  'web',
])
export type ContainerType = z.infer<typeof ContainerType>

export const ExitStrategy = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('deeplink'),
    target: z.string().regex(/^[a-z][a-z0-9+.-]*:\/\/\S*$/i, 'phải là scheme://path'),
    fallback_text: z.string(),
  }),
  z.object({
    type: z.literal('redirect'),
    target: z.string().url(),
    fallback_text: z.string(),
  }),
  /** App tự phát hiện URL sentinel rồi đóng WebView. Không có gì để FE điều hướng. */
  z.object({
    type: z.literal('sentinel'),
    target: z.string().url(),
    fallback_text: z.string(),
  }),
])
export type ExitStrategy = z.infer<typeof ExitStrategy>

export const Container = z.object({
  type: ContainerType,
  /** App đã có nav bar native → `none`, đừng vẽ header thứ hai. */
  chrome: z.enum(['full', 'compact', 'none']),
  back: z.enum(['native', 'app_handled']),
  exit: ExitStrategy,
})
export type Container = z.infer<typeof Container>

export const Capabilities = z.record(Capability, z.boolean())
export type Capabilities = z.infer<typeof Capabilities>

/** Capability mà mỗi loại container thực sự cung cấp được. */
export const CONTAINER_CAPABILITIES: Record<ContainerType, Record<string, boolean>> = {
  app_webview: { camera: false, file_upload: true, download: false },
  app_browser_tab: { camera: true, file_upload: true, download: true },
  web: { camera: true, file_upload: true, download: true },
}
